(function($, undefined) {
  'use strict';
  var contactFormBtn;
  var formCom;
  var recaptcha;

  var sendContactFormEmailClass = function() {
    var t = $(this);
    var count = t.data('count');
    var form = t.closest($('.contactForm-Container'));

    var subject = $('.contactForm-subject', form).val();
    var email = $('.contactForm-email', form).val();
    var targetEmail = $('.targetEmail', form) ? $('.targetEmail', form).val() : '';
    var content = null;
    var captchaIsOk = true;

    try {
      content = tinyMCE.get('contactForm-content', form).getContent();
    } catch (exception) {
      content = $('.contactForm-content', form).val();
    }

    var appendField = '';
    if ($('.fieldName1') !== null) {
      var total = 9;
      if (count) {
        total = count;
      }
      for (var i = 1; i < total; i++) {
        appendField += '&fieldName' + i + '=' + encodeURIComponent($('.fieldName' + i, form).val());
        if ($('.field' + i, form).attr('type') == 'checkbox') {
          if ($('.field' + i, form).checked) {
            appendField += '&field' + i + '=checked.';
          } else {
            appendField += '&field' + i + '=not checked.';
          }
        } else {
          appendField += '&field' + i + '=' + encodeURIComponent($('.field' + i, form).val());
        }
      }
      appendField += '&count=' + total + '&targetEmail=' + targetEmail;
    }
    var captcha = $('.g-recaptcha', form);
    if (captcha.length) {
      var captchaResp = grecaptcha.getResponse();

      if (captchaResp.length === 0) {
        captchaIsOk = false;
      } else {
        appendField += '&captcha=' + grecaptcha.getResponse();
      }
    } else if (recaptchaResponse && typeof recaptchaResponse === 'string') {
      appendField += '&captcha=' + recaptchaResponse;
    }

    formCom.validateForm(form);

    if (form.hasClass('has-error')) {
      // popErrorDisplayOnSite('error.message.emptyForm');
      $('.contact-form-form-error', form).slideDown(200);
    } else {
      $('.contact-form-form-error', form).slideUp(200);
    }

    if (!captchaIsOk) {
      $('.contact-form-captcha-error', form).slideDown(200);
    } else {
      $('.contact-form-captcha-error', form).slideUp(200);
    }

    if (!form.hasClass('has-error') && captchaIsOk) {
      ajax(
        actionPath +
          'contactUs?subject=' +
          encodeURIComponent(subject) +
          '&email=' +
          encodeURIComponent(email) +
          '&content=' +
          encodeURIComponent(content) +
          appendField,
        sendContactFormEmailConfirmClass(form)
      );
    } else {
      grecaptcha.reset();
    }
  };

  var sendContactFormEmailConfirmClass = function(form) {
    var bigCtn = form.closest('.contactForm-Container-big');

    $('.contactForm-Container', bigCtn).slideUp(1000, function() {
      $('.contactForm-sent', bigCtn).slideDown(300);
    });
  };

  var popErrorCompleteDisplayOnSite = function(response) {
    footerErrorMessage.slideDown(200);
  };

  var init = function(page) {
    contactFormBtn = $('.js-contact-form-send');
    formCom = Fw.component.models().form;
    recaptcha = Fw.component.models().recaptcha.recaptcha;

    if (contactFormBtn.hasClass('render-g-recaptcha')) {
      contactFormBtn.each(function() {
        var btn = this;
        if (btn.classList.contains('render-g-recaptcha')) {
          recaptcha(btn, function(response) {
            sendContactFormEmailClass.call(btn, response);
          });
        }
      });
    } else {
      contactFormBtn.click(sendContactFormEmailClass);
    }
  };

  $(window).ready(function() {
    init();
  });
})(jQuery);
